import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { Wrapper } from './styled';
export var Frame = /*#__PURE__*/function (_React$Component) {
  function Frame() {
    var _this;
    _classCallCheck(this, Frame);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Frame, [].concat(args));
    _defineProperty(_this, "handleClick", function (event) {
      var onClick = _this.props.onClick;
      if (onClick) {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
      }
    });
    _defineProperty(_this, "handleKeyPress", function (event) {
      if (event.key !== ' ' && event.key !== 'Enter') {
        return;
      }
      var onClick = _this.props.onClick;
      if (onClick) {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
      }
    });
    return _this;
  }
  _inherits(Frame, _React$Component);
  return _createClass(Frame, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        isSelected = _this$props.isSelected,
        children = _this$props.children,
        onClick = _this$props.onClick,
        innerRef = _this$props.innerRef,
        testId = _this$props.testId;
      var isInteractive = Boolean(onClick);
      return /*#__PURE__*/React.createElement(Wrapper, {
        ref: innerRef,
        isSelected: isSelected,
        tabIndex: isInteractive ? 0 : undefined,
        role: isInteractive ? 'button' : undefined,
        onClick: this.handleClick,
        onKeyPress: this.handleKeyPress,
        "data-testid": testId
      }, children);
    }
  }]);
}(React.Component);